module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/ahead2-df943737dc88039c32ecc2941220e48e.jpg";